"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Clickstream_key = exports.SESSION_ID = exports.VERSION = exports.props = exports.ERROR_CONSTS = exports.DTH_SERVICE_NAME = exports.DATE = exports.CONTAINER_WIDTH = exports.CONTAINER_HEIGHT = exports.VISITOR_ID = exports.REQUESTOR_SOURCE = exports.PAGE_NAME = exports.LOB = exports.FETCH_CITY_URL = exports.OMNIWIDGET_PROD_URI = void 0;
exports.OMNIWIDGET_PROD_URI = "https://www.airtel.in/omni-serviceability/?";
exports.FETCH_CITY_URL = "https://digi-api.airtel.in/omniwidget/rest/pincode/validate/address";
exports.LOB = 'lob';
exports.PAGE_NAME = 'pageName';
exports.REQUESTOR_SOURCE = 'requestorSource';
exports.VISITOR_ID = 'visitorId';
exports.CONTAINER_HEIGHT = 'containerHeight';
exports.CONTAINER_WIDTH = 'containerWidth';
exports.DATE = 'date';
exports.DTH_SERVICE_NAME = 'DTH_BLINK_OE';
exports.ERROR_CONSTS = {
    ERROR_BOUNDARY: 'ErrorBoundary',
    FETCH_FAILED: 'HTMLFetchFailed',
    API_FAILURE: 'GetCityFromPincodeFailed',
    ERROR_CODE: 40
};
exports.props = {
    lob: "BROADBAND",
    pageName: 'B2B_LEAD',
    requestorSource: 'DIGITAL_STORE_FWA',
    eventListener: console.log,
    integrationType: 'CONTAINER',
    widgetLoadTimeout: 5000,
    maxRetryCount: 3,
    heartBeatTimeOut: 6000,
    args: {
        "cityName": "Pune",
        "stateName": "Maharashtra",
        "circleId": 108,
        "isCityLco": true
    },
    customUri: "https://tnd.airtel.com/omni-fwa/?",
    mountCount: 0
};
exports.VERSION = 'version';
exports.SESSION_ID = 'sessionId';
exports.Clickstream_key = {
    appName: "Omniwidget",
    appKey: "Omn1w1dg3t"
};
